<template>
  <div v-if="show" id="annotationToolRibbon" class="ribbon">
    <div class="ribbon__group">
      <template v-if="hasImage">
        <SVGIcon
          id="downloadImageBtn"
          class="ribbon__button"
          aria-label="Download image"
          :iconName="'download'"
          :showHover="false"
          :type="''"
          :title="'Download image'"
          :width="32"
          :height="32"
          @click="downloadImage"
        />
        <hr class="ribbon__vr">
      </template>
      <span>{{ zoom }}%</span>
      <IconButton
        id="zoomToFitBtn"
        class="ribbon__button"
        aria-label="Zoom To Fit (Space)"
        :icon="'zoom_to_extents'"
        :showHover="false"
        :type="''"
        :title="'Zoom To Fit (Space)'"
        @click="handleZoomToFit"
      />
      <IconButton
        id="zoomToSelectionBtn"
        class="ribbon__button"
        aria-label="Zoom To Selection (Selection + Space)"
        :disabled="!hasSelection"
        :icon="'zoom_to_selection'"
        :showHover="false"
        :type="''"
        :title="'Zoom To Selection (Selection + Space)'"
        @click="handleZoomToSelection"
      />
    </div>
  </div>
</template>

<script>
import IconButton from '@/components/IconButton.vue';
import SVGIcon from '@/components/SVGIcon.vue';
import { roundNumber } from '@/assets/js/utils.js';

export default {
  name: 'AnnotationToolViewingModeControls',
  components: {
    IconButton,
    SVGIcon,
  },
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    hasImage: {
      type: Boolean,
      default: true,
    },
    canvasScale: {
      type: Number,
      default: 100,
    },
    hasSelection: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'zoom-to-fit',
    'zoom-to-selection',
    'download-image',
  ],
  computed: {
    zoom() {
      return roundNumber(this.canvasScale * 100, 0);
    },
  },
  methods: {
    handleZoomToFit() {
      this.$emit('zoom-to-fit');
    },
    handleZoomToSelection() {
      this.$emit('zoom-to-selection');
    },
    async downloadImage() {
      this.$emit('download-image');
    },
  },
};
</script>

<style lang="scss" scoped>
.ribbon {
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  flex-direction: row;
  width: fit-content;
  height: 40px;
  padding: 2px 16px;
  justify-content: space-between;
  font-weight: 500;
  box-shadow: 0 0 3px gray, 0 0 10px gray;
  border-radius: 4px;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  z-index: 9;
  @include themify() {
    color: themed('ribbon-icons-color');
    background: themed('ribbon-bg-transparent');
  }

  &__group {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
  }

  &__vr {
    display: flex;
    width: 1px;
    height: 60%;
    margin: 0;
  }

  &__button {
    display: flex;
    min-width: 22px;
    height: 22px;
    color: inherit;
    background: none;
    border: none;
    font-size: 0.875rem;
    line-height: 1rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: .05em;
    align-items: center;
    cursor: pointer;

    &:hover:not(:disabled), &.active:not(:disabled) {
      @include themify() {
        box-shadow: 0 0 0 4px themed('icon-hover-color');
        background-color: themed('icon-hover-color');
      }
      border-radius: 4px;
    }

    &:disabled {
      cursor: default;
      @include themify() {
        color: themed('color-disabled');
      }
    }
  }
}

</style>
